import Acuris from "../../assets/company-logos/Acuris.png";
import NominoData from "../../assets/company-logos/Nominodata.png";
import ZeroBounce from "../../assets/company-logos/ZeroBounce.svg";
import Maxmind from "../../assets/company-logos/Maxmind.png";
import Seon from "../../assets/company-logos/Seon.png";
import PIPL from "../../assets/company-logos/pipl.svg";
import DataZoo from "../../assets/company-logos/datazoo.png";
import GlobalDataConsortium from "../../assets/company-logos/GlobalDataConsortium.png";
import TeleSign from "../../assets/company-logos/TeleSign.png";
import Ekata from "../../assets/company-logos/Ekata.png";

const data = {
  usecaseInfo: {
    name: "KYC Workflow Automation",
    description:
      "A single platform for seamless onboarding and verification of customers globally.",
  },
  recipesInfo: {
    title: "Onboard customers in seconds",
    description:
      "Access API-ready solutions for identity verification, fraud risk, global AML and watchlist screening, social media presence, and financial verification, among many others.",
  },
  recipes: [
    {
      type: "People Data",
      title: "Identity Verification",
      description: "Verify the name, address, and phone number of an individual.",
    },
    {
      type: "People Data",
      title: "Watchlist and Fraud Screening",
      description:
        "Check an individual's presence in international AML and fraud watchlists and confirm the validity of a customer's provided email and phone.",
    },
    {
      type: "People Data",
      title: "Email Identity Verification",
      description:
        "Validate an individual's email address based on its age, domain, risk-level across online activities, and mapping to the applicant.",
    },
    {
      type: "People Data",
      title: "Phone Validation",
      description:
        "Validate an individual's phone number based on its connection status, carrier, risk-level, and mapping to the applicant.",
    },
    {
      type: "People Data",
      title: "Consumer Social Media Profiles",
      description: "Check the presence and activity of social media profiles for an individual.",
    },
    {
      type: "Other Data",
      title: "...And Many More",
      description: "Access 100's of api-ready recipes.",
      ctaText: "Access Recipe Catalog",
    },
  ],
  dataPartners: {
    title: "Sample Data Providers",
    description: "Access to hundreds of data partners worldwide",
    logos: [
      {
        name: "Global Data Consortium",
        img: GlobalDataConsortium,
      },
      {
        name: "DataZoo",
        img: DataZoo,
      },
      {
        name: "Nomino Data",
        img: NominoData,
      },
      {
        name: "Acuris",
        img: Acuris,
      },
      {
        name: "PIPL",
        img: PIPL,
      },
      {
        name: "Seon",
        img: Seon,
      },
      {
        name: "Maxmind",
        img: Maxmind,
      },
      {
        name: "ZeroBounce",
        img: ZeroBounce,
      },
      {
        name: "Ekata",
        img: Ekata,
      },
      {
        name: "TeleSign",
        img: TeleSign,
      },
    ],
  },
  resourcesInfo: {
    title: "Resources",
    description: "The latest news, technologies, and resources from our team.",
  },
  resources: [
    {
      title: "Synthetic Identities, Genuine Fraud",
      url: "https://demyst.com/blog/synthetic-identities-genuine-fraud",
      featured_image: "https://cdn.buttercms.com/xb1BchPSRxKhMXwcPkyJ",
      date: "2021-10-16",
      description:
        "Synthetic identity theft is the fastest growing financial crime in the United States, and it poses serious risks for financial institutions (FIs) that are looking to streamline their customer onboarding in an effort to scale customer acquisition. Example industries include neo-banks, BNPL providers, and non-bank FIs with credit card products. Criminals can create “synthetic” identities to avoid detection by combining legitimate information, fabricated data, and online activity.",
      more: "",
    },
    {
      title: "Leveraging External Data to Address Rising Compliance Costs",
      url: "https://demyst.com/blog/leveraging-external-data-to-address-rising-compliance-costs",
      featured_image: "https://cdn.buttercms.com/czi74SoSpyDFZUuZrbTQ",
      date: "2021-10-08",
      description:
        "According to the 2021 True Cost of Financial Crime Compliance report, financial institutions spent $213.9 billion on regulatory compliance in 2020, up from $180.9 billion the previous year. These costs are expected to continue climbing — and the increased expenses will reduce productivity in APAC, EMEA and Latin America.",
      more: "",
    },
    {
      title: "How to Verify a U.S. Person’s Address",
      url: "https://demyst.com/blog/how-to-verify-a-us-persons-address",
      featured_image: "https://cdn.buttercms.com/HaKlsh1RRouay02w9jlQ",
      date: "2021-10-08",
      description:
        "Not only is address verification an important tool for fraud prevention, it can also be used to improve customer service by pre-filling forms, updating internal records, and making other enhancements to the user experience. However, companies need to actively monitor the accuracy of their records",
      more: "",
    },
    {
      title: "Mitigating Marketplace Onboarding Risk With External Data",
      url: "https://demyst.com/blog/mitigating-marketplace-onboarding-risk-with-external-data",
      featured_image: "https://cdn.buttercms.com/AejodJLgQ9c9Ahkuo32Q",
      date: "2021-09-20",
      description:
        "Last week, the Demyst team attended the Marketplace Risk Management Conference in San Francisco attended by notable players such as AirBnB, Uber, Lyft, and DoorDash, as well as dozens of emerging players and service providers (external data providers, legal firms, insurers, etc.). There was a notable buzz in the air as marketplaces, particularly in the ridesharing industry, are aiming for a strong comeback as economies recover from the slump associated with the pandemic. And as it was our first conference in a while, we welcomed it!",
      more: "",
    },
  ],
};

export default data;
